'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _handleActions;

import { handleActions } from 'flux-actions';
import { Map as ImmutableMap } from 'immutable';
import * as ActionTypes from 'MeetingsLib/redux/actions/ActionTypes';
var initialState = ImmutableMap();
export default handleActions((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.MEETING_CREATE_FAILED, function (requestStatus, action) {
  return requestStatus.set('meetingCreate', action.payload.error);
}), _defineProperty(_handleActions, ActionTypes.MEETING_RESCHEDULE_FAILED, function (requestStatus, action) {
  return requestStatus.set('meetingReschedule', action.payload.error);
}), _defineProperty(_handleActions, ActionTypes.PUBLIC_AVAILABILITY_INFO_FETCH_FAILED, function (requestStatus, action) {
  return requestStatus.set('publicAvailabilityInfoFetch', action.payload.error);
}), _handleActions), initialState);